import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { API } from "@/lib/site";

export const CoverUpload = ({
  onUploaded,
  accept = "image/jpeg,image/png,image/webp,image/gif",
  label = "Upload from device",
  testId = "cover-upload",
}) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const data = new FormData();
      data.append("file", file);
      const { data: res } = await axios.post(`${API}/uploads`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("hs_admin_token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      onUploaded(res.url, file.name);
      toast.success("File uploaded.");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Upload failed.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        data-testid={`${testId}-input`}
        onChange={handleFile}
      />
      <button
        type="button"
        data-testid={`${testId}-button`}
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="inline-flex items-center gap-2 rounded-full border border-dashed border-teal-500/40 px-5 py-2.5 text-xs font-semibold text-teal-300 transition-all duration-300 hover:border-teal-400 hover:bg-teal-500/10 disabled:opacity-60"
      >
        {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
        {uploading ? "Uploading..." : label}
      </button>
    </>
  );
};
